import { useEffect, useMemo, useRef } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { BackButton, Loader } from "shared/components";
import { Spacer } from "shared/layout";
import { FourOhFour } from "shared/pages";
import { CenterContent } from "shared/styles";
import { ContentWidth } from "shared/styles/constants";
import { copy } from "shared/assets";
import {
  bandMetaSelector,
  bandSelectorCreator,
  dispatchGetBandAction,
  dispatchGetSubscriptionsAction,
} from "Bands/state";
import { BandInfo, SubscriptionHistory } from "./containers";
import { BAND_PATHS } from "Bands/router";
import { IAPIState } from "shared/types";

const adminCopy = copy.adminDashboard;

export const AdminBand = () => {
  const dispatch = useDispatch();

  const { bandId } = useParams<{ bandId: string }>();
  const bandIdSelector = useMemo(() => bandSelectorCreator(bandId), [bandId]);
  const band = useSelector(bandIdSelector);

  // when selected band ID changes, fetch more info about the band
  const { api: apiMeta } = useSelector(bandMetaSelector(bandId));
  const fetchedBandId = useRef<string>();
  useEffect(() => {
    dispatchGetBandAction(dispatch, bandId);
    fetchedBandId.current = bandId;
  }, [bandId, dispatch]);

  // fetch band subscriptions
  const fetchedSubscriptionsBandId = useRef<string>();
  useEffect(() => {
    if (bandId && fetchedSubscriptionsBandId.current !== bandId) {
      fetchedSubscriptionsBandId.current = bandId;
      dispatchGetSubscriptionsAction(dispatch, {
        band: bandId,
      });
    }
  }, [bandId, dispatch]);

  if (apiMeta?.status === IAPIState.pending && !band) return <Loader />;
  if (!band) return <FourOhFour />;

  return (
    <CenterContent width={ContentWidth.wide}>
      <Spacer size="s">
        <BackButton to={BAND_PATHS.ADMIN_DASHBOARD} label={adminCopy.buttons.back} />
        <BandInfo band={band} />
        <SubscriptionHistory band={band} />
      </Spacer>
    </CenterContent>
  );
};
